import React, { useState } from "react";
import { Link } from "react-router-dom";
import { blogs } from "../data/blogsData";
import { Helmet } from "react-helmet-async";

const Blog = () => {

  const [search, setSearch] = useState("");

  const filteredBlogs = blogs.filter((blog) => {

  const searchText = search.toLowerCase();

  // combine all content text into one string
  const contentText = blog.content
    ? blog.content.map(c => c.text).join(" ").toLowerCase()
    : "";

  return (
    blog.title.toLowerCase().includes(searchText) ||
    blog.category.toLowerCase().includes(searchText) ||
    (blog.desc && blog.desc.toLowerCase().includes(searchText)) ||
    contentText.includes(searchText)
  );
});

  const featured = filteredBlogs[0];
  const restBlogs = filteredBlogs.slice(1);

  return (
    <div className="bg-[#f7f8fc] min-h-screen">
      <Helmet>

  {/* PAGE TITLE */}
  <title>Gurukul ERP Blogs | School ERP Insights & Education Technology</title>

  {/* META DESCRIPTION */}
  <meta
    name="description"
    content="Explore Gurukul ERP Blogs for school management insights, attendance tracking, fee automation, CBSE ERP solutions and digital education tools."
  />

  {/* KEYWORDS */}
  <meta
    name="keywords"
    content="school erp blog, gurukul erp, education software blog, attendance system blog, school management system india"
  />

  {/* CANONICAL URL */}
  <link rel="canonical" href="https://www.gurukulerp.in/blogs" />

  {/* OPEN GRAPH (FACEBOOK SEO) */}
  <meta property="og:title" content="Gurukul ERP Blogs" />
  <meta
    property="og:description"
    content="Latest ERP insights for schools, attendance management, CBSE ERP software and digital education tools."
  />
  <meta
    property="og:image"
    content="https://ik.imagekit.io/gqpk1bdvr/Admin_dashboard.jpeg"
  />
  <meta property="og:type" content="website" />

  {/* TWITTER SEO */}
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Gurukul ERP Blogs" />
  <meta
    name="twitter:description"
    content="Read Gurukul ERP blogs about modern school ERP software and education technology."
  />

</Helmet>

      {/* ===== PAGE TITLE ===== */}
      <div className="max-w-[1400px] mx-auto px-6 pt-20">
        <h1 className="text-5xl font-bold text-gray-800 mb-10">
          Gurukul ERP Blogs
        </h1>
      </div>

      {/* ===== TOP SECTION ===== */}
      <div className="max-w-[1400px] mx-auto px-6 grid lg:grid-cols-[1fr_360px] gap-12">

        {/* LEFT FEATURED BLOG */}
        {featured && (
          <div>
            <div className="bg-white rounded-3xl shadow-sm overflow-hidden">
              <img
                src={featured.image}
                alt={featured.title}
                className="w-full h-[380px] object-cover"
              />
            </div>

            <div className="mt-8">
              <h2 className="text-3xl font-semibold text-gray-800">
                {featured.title}
              </h2>

              <p className="text-orange-500 font-medium mt-3">
                {featured.category}
              </p>

              <p className="text-gray-500 mt-2 text-sm">
                {featured.date} • {featured.readTime}
              </p>

              <p className="text-gray-600 mt-4 max-w-3xl leading-relaxed">
                {featured.desc}
              </p>

              <Link
                to={`/blogs/${featured.slug}`}
                className="inline-block mt-4 text-orange-500 font-semibold"
              >
                Read the full blog →
              </Link>
            </div>
          </div>
        )}

        {/* ===== RIGHT SIDEBAR ===== */}
        <div className="space-y-10">

          {/* SEARCH BOX */}
          <div className="bg-white rounded-2xl shadow-sm p-5 flex gap-3">
            <input
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              placeholder="Search blog..."
              className="flex-1 border rounded-xl px-4 py-3 outline-none"
            />

            <button className="bg-orange-500 text-white px-6 rounded-xl font-semibold">
              Search
            </button>
          </div>

          {/* POPULAR POSTS */}
          <div className="bg-white rounded-2xl shadow-sm p-6">
            <h3 className="text-xl font-semibold mb-6">
              Popular Posts
            </h3>

            <div className="space-y-5">
              {blogs.slice(0,4).map((post)=>(
                <Link
                  key={post.id}
                  to={`/blogs/${post.slug}`}
                  className="flex gap-4 group"
                >
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-24 h-16 object-cover rounded-xl"
                  />

                  <div>
                    <p className="text-sm text-gray-800 group-hover:text-orange-500 transition">
                      {post.title}
                    </p>

                    <p className="text-xs text-gray-500 mt-1">
                      {post.date} • {post.readTime}
                    </p>

                    <span className="text-orange-500 text-sm font-medium">
                      Read the full blog →
                    </span>
                  </div>

                </Link>
              ))}
            </div>
          </div>

        </div>
      </div>

      {/* ===== MAIN BLOG LIST ===== */}
      <div className="max-w-[1400px] mx-auto px-6 py-16">

        <h2 className="text-2xl font-semibold text-gray-800 mb-10">
          All Posts
        </h2>

        {filteredBlogs.length === 0 && (
          <p className="text-gray-500">No blog found.</p>
        )}

        <div className="grid md:grid-cols-2 gap-12">

          {restBlogs.map((blog)=>(
            <div
              key={blog.id}
              className="bg-white rounded-3xl shadow-sm hover:shadow-lg transition overflow-hidden group"
            >
              <img
                src={blog.image}
                alt={blog.title}
                className="h-64 w-full object-cover"
              />

              <div className="p-7">
                <h3 className="text-xl font-semibold text-gray-800 group-hover:text-orange-500 transition">
                  {blog.title}
                </h3>

                <p className="text-orange-500 mt-3 text-sm">
                  {blog.category}
                </p>

                <p className="text-gray-500 mt-1 text-sm">
                  {blog.date} • {blog.readTime}
                </p>

                <p className="text-gray-600 mt-4 leading-relaxed">
                  {blog.desc}
                </p>

                <Link
                  to={`/blogs/${blog.slug}`}
                  className="inline-block mt-5 text-orange-500 font-semibold"
                >
                  Read the full blog →
                </Link>
              </div>
            </div>
          ))}

        </div>

      </div>
    </div>
  );
};

export default Blog;